import React, { useEffect, useState } from "react";
import { timeToSeconds } from "../../../../Utilitie";
import GroupedBarChart from "../../../../CHARTS/GroupedBarChart";
import NoDataFound from "../../../../Extra/NoDataFound";
import { BiSolidReport } from "react-icons/bi";
import AdrmGraphMaster from "../../TableView/ADRMDailyBlockPosition/Graph/AdrmGraphMaster";
const timeKeys = [
  "Engg_Demand",
  "Agreed_Demand",
  "Granted_Duration",
  "Availed",
];
const countKeys = [
  "No_Of_Engg_Demand",
  "No_Of_Agreed_Demand",

  "Granted_Count",
  "Availed_Count",
];

const BlockPositionChart = ({ data, dataForTable }) => {
  const [finalData, setFinalData] = useState(null);
  const [chartDataCount, setChartDataCount] = useState(null);
  const [chartDataTime, setChartDataTime] = useState(null);

  const getFY = (dateString) => {
    if (!dateString || typeof dateString !== "string") return "Unknown";
    const date = new Date(dateString);
    if (isNaN(date)) return "Unknown";
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    return month >= 4
      ? `${year}-${(year + 1).toString().slice(-2)}`
      : `${year - 1}-${year.toString().slice(-2)}`;
  };

  useEffect(() => {
    if (data?.length > 0) {
      const fyMap = {};
      data.forEach((item) => {
        if (!item || !item.reportDate) return;
        const fy = getFY(item.F_Year);
        if (!fyMap[fy]) fyMap[fy] = [];
        fyMap[fy].push(item);
      });
      const groupedTotals = data.reduce((acc, item) => {
        if (!item.F_Year) return acc;
        // const date = item.reportDate?.split("T")[0]; // keep only YYYY-MM-DD
        const date = item.F_Year;
        const num = (val) => Number(val) || 0;
        const text = (val) => (val || "").toString().toLowerCase();
        // console.log(date);
        if (!acc[date]) {
          acc[date] = {
            reportDate: date,
            No_Of_Engg_Demand: 0,
            Engg_Demand: 0,
            No_Of_Agreed_Demand: 0,
            Agreed_Demand: 0,
            Availed_Not_Count: 0,
            Granted_Duration: 0,
            Availed: 0,
            Granted_Count: 0,
            Availed_Count: 0,
          };
        }

        acc[date].No_Of_Engg_Demand += num(item.No_Of_Demand_By_Engg);
        acc[date].Engg_Demand += Number(timeToSeconds(item?.Engg_Demand));
        acc[date].No_Of_Agreed_Demand += num(item.No_Of_Demand_Agreed_GIVEN);
        acc[date].Agreed_Demand += Number(timeToSeconds(item?.Agreed_Demand));
        acc[date].Availed += Number(timeToSeconds(item?.Availed));
        acc[date].Granted_Duration += Number(
          timeToSeconds(item?.Granted_Duration),
        );

        if (text(item.Availed_Not).includes("availed")) {
          acc[date].Availed_Not_Count += 1;
        }
        if (item.Availed_Not && item.Availed_Not === "AVAILED") {
          acc[date].Availed_Count += 1;
        }
        if (item.Granted_Not && item.Granted_Not === "GRANTED") {
          acc[date].Granted_Count += 1;
        }

        return acc;
      }, {});

      // Convert the grouped object to an array
      const result = Object.values(groupedTotals);
      // console.log(result);
      setFinalData(result);
    }
  }, [data]);
  const transformData = (result, keys) => {
    let dimensions = [];
    const seriesMap = {};
    const tempDimensions = [];
    result.forEach((obj) => {
      const year = obj.reportDate;
      if (!tempDimensions.includes(year)) {
        tempDimensions.push(year);
      }
      keys.forEach((key) => {
        if (!seriesMap[key]) {
          seriesMap[key] = { product: key.replace("_", " ") };
        }
        seriesMap[key][year] = obj[key] ?? 0;
      });
    });
    tempDimensions.sort();
    dimensions = ["product", ...tempDimensions];
    const series = Object.values(seriesMap);
    return { dimensions, series };
  };
  useEffect(() => {
    if (finalData && finalData.length > 0) {
      setChartDataTime(transformData(finalData, timeKeys));
      setChartDataCount(transformData(finalData, countKeys));
    }
  }, [finalData]);

  return (
    <div
      className="row papaDiv mx-0 my-2 p-2 rounded-3"
      style={{
        background: "#f7faff",
        border: "1px solid #d7e2ef",
        boxShadow: "0 4px 16px rgba(6, 59, 135, 0.08)",
      }}
    >
      {/* Header */}
      <div
        className="d-flex flex-wrap align-items-center justify-content-between gap-2 p-3 rounded-3 text-white"
        style={{
          background:
            "linear-gradient(135deg, #870606 0%, #b12b2b 72%, #730808 100%)",
        }}
      >
        <h5 className="mb-0 d-flex align-items-center gap-2 fw-semibold">
          <BiSolidReport size={22} />
          Block Position
        </h5>

        <div
          className="small rounded-pill px-3 py-2"
          style={{
            background: "rgba(255,255,255,0.14)",
            border: "1px solid rgba(255,255,255,0.25)",
          }}
        >
          <span className="fw-semibold">Section:</span>{" "}
          {dataForTable?.section?.length
            ? dataForTable.section.join(", ")
            : "All Sections"}
        </div>
      </div>

      {data?.length > 0 ? (
        <div className="row g-3 mt-1">
          {/* Duration-wise chart */}
          <div className="col-12 col-xl-6">
            <div
              className="h-100 p-3 rounded-3 bg-white"
              style={{
                border: "1px solid #d7e2ef",
                boxShadow: "0 2px 8px rgba(6, 59, 135, 0.05)",
              }}
            >
              <div className="d-flex align-items-center gap-2 mb-2">
                <span
                  className="rounded-2"
                  style={{
                    width: "4px",
                    height: "28px",
                    background: "#0a57bb",
                  }}
                />

                <div>
                  <h6 className="mb-1 fw-bold" style={{ color: "#063b87" }}>
                    Block Position
                  </h6>
                  <small className="text-secondary">
                    Duration-wise Analysis
                  </small>
                </div>
              </div>

              <hr style={{ borderColor: "#d7e2ef" }} />

              {chartDataTime?.series?.length > 0 ? (
                <GroupedBarChart
                  data={chartDataTime}
                  from="Block_T"
                  chartType="bar"
                />
              ) : (
                <div className="text-center text-secondary py-4">
                  No duration data found
                </div>
              )}
            </div>
          </div>

          {/* Count-wise chart */}
          <div className="col-12 col-xl-6">
            <div
              className="h-100 p-3 rounded-3 bg-white"
              style={{
                border: "1px solid #d7e2ef",
                boxShadow: "0 2px 8px rgba(6, 59, 135, 0.05)",
              }}
            >
              <div className="d-flex align-items-center gap-2 mb-2">
                <span
                  className="rounded-2"
                  style={{
                    width: "4px",
                    height: "28px",
                    background: "#087344",
                  }}
                />

                <div>
                  <h6 className="mb-1 fw-bold" style={{ color: "#063b87" }}>
                    Block Position
                  </h6>
                  <small className="text-secondary">Count-wise Analysis</small>
                </div>
              </div>

              <hr style={{ borderColor: "#d7e2ef" }} />

              {chartDataCount?.series?.length > 0 ? (
                <GroupedBarChart
                  data={chartDataCount}
                  height={200}
                  from="Block_C"
                  chartType="bar"
                />
              ) : (
                <div className="text-center text-secondary py-4">
                  No count data found
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="bg-white rounded-3 mt-3 p-3">
          <NoDataFound />
        </div>
      )}
    </div>
  );
};
export default BlockPositionChart;
